import React from 'react';

import { getPlainDisplayValue, getSortedValues, getVisibleMetricIndex } from '@libs/NwFeatures';

import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon, { NwBoolIcon } from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

// le metriche del genere sbagliato sono già escluse da getSortedValues: qui si disegna quel che resta
export const FeatureGroupMetrics = ({ sortedValues, itemFeature, metricIndex, onMetricChange }) => (
    <span className="feature-metrics">
        {sortedValues.map((sv, index) => (
            <span
                key={sv.metric}
                className={index === metricIndex ? 'active-metric' : ''}
                onClick={() => onMetricChange(itemFeature.ID, index)}
            >
                {sv.metric}
            </span>
        ))}
    </span>
);

export const FeatureGroupContent = ({
    feature,
    itemFeature,
    featureName,
    isPublicValue = false,
    showMetrics = true,
    breakpoints,
    featuresIndex,
    gender,
    getMetricIndex,
    onMetricChange,
    onEditFeature,
}) => {
    let textsize = '';
    const getFeatureValueClassName = (className = '') =>
        ['feature-value', isPublicValue ? 'public-feature-value' : '', className].filter(Boolean).join(' ');
    switch (itemFeature.TypeName.toLowerCase()) {
        case 'conversion': {
            const sortedValues = feature
                ? getSortedValues(feature.DisplayValue, itemFeature.ConversionID, featuresIndex, { gender })
                : [];
            const metricIndex = getVisibleMetricIndex(sortedValues, getMetricIndex(itemFeature));
            const selectedValue = sortedValues[metricIndex];

            // nessuna metrica da mostrare (display value assente, o metriche configurate che non
            // esistono più nella conversion table): resta il box vuoto, cliccabile per la modifica
            if (!selectedValue) {
                return <span className={getFeatureValueClassName()} onClick={() => onEditFeature(featureName)} />;
            }

            return breakpoints === 1 ? (
                <span className={getFeatureValueClassName()} onClick={() => onEditFeature(featureName)}>
                    {selectedValue.value} {selectedValue.metric}
                </span>
            ) : (
                <>
                    <span className={getFeatureValueClassName()} onClick={() => onEditFeature(featureName)}>
                        {selectedValue.value}
                    </span>
                    {showMetrics && (
                        <FeatureGroupMetrics
                            sortedValues={sortedValues}
                            itemFeature={itemFeature}
                            metricIndex={metricIndex}
                            onMetricChange={onMetricChange}
                        />
                    )}
                </>
            );
        }
        case 'boolean':
            return (
                <span className={getFeatureValueClassName()} onClick={() => onEditFeature(featureName)}>
                    {feature.Value.toLowerCase() === 'true' ? (
                        <NwBoolIcon value={true} fontSize="1.5em" />
                    ) : (
                        <NwBoolIcon value={false} fontSize="1.5em" />
                    )}
                </span>
            );
        case 'choice':
        case 'multichoice': {
            // multichoice arriva come elenco di valori, gli altri tipi come singolo valore
            const choices = Array.isArray(feature.DisplayValue) ? feature.DisplayValue : null;
            const myval = getPlainDisplayValue(feature.DisplayValue);
            if (myval.length > 6) {
                if (myval.length > 20) {
                    textsize = 'text-small';
                } else {
                    textsize = 'text-medium';
                }
            }
            if (choices && choices.length > 1) {
                return (
                    <span
                        className={getFeatureValueClassName(`${textsize} text-list`)}
                        onClick={() => onEditFeature(featureName)}
                    >
                        {choices.map((item, index) => (
                            <em key={index}>&bull; {item}</em>
                        ))}
                    </span>
                );
            }
            return (
                <span className={getFeatureValueClassName(textsize)} onClick={() => onEditFeature(featureName)}>
                    {myval}
                </span>
            );
        }
        case 'rating':
            return (
                <FlexContainer
                    className={isPublicValue ? 'public-feature-value' : ''}
                    mg={breakpoints !== 1 && '8px 0 0'}
                    onClick={() => onEditFeature(featureName)}
                >
                    {Array(parseInt(feature.Value))
                        .fill(null)
                        .map((rating, key) => {
                            return (
                                <React.Fragment key={`star-${key}`}>
                                    <NwIcon icon={byPrefixAndName.fass['star']} style={{ fontSize: 13 }} />
                                    &nbsp;
                                </React.Fragment>
                            );
                        })}
                </FlexContainer>
            );
        default:
            if (feature.Value && feature.Value.length > 6) {
                if (feature.Value.length > 20) {
                    textsize = 'text-small';
                } else {
                    textsize = 'text-medium';
                }
            }
            return (
                <span className={getFeatureValueClassName(textsize)} onClick={() => onEditFeature(featureName)}>
                    {feature.Value}
                </span>
            );
    }
};
